@if (dataStreamGroup) {
  <div>
    <h3>{{ dataStreamGroup.name }}</h3>
    @if (loading) {
      <div class="text-center px-5 mt-5 mb-4">
        <fa-icon icon="spinner" animation="spin" size="3x"></fa-icon>
      </div>
    }
    @if (!loading && !dataStreams?.length) {
      <p>{{ "Template.DataStreamGroupComponent.text_noDataProvided" | translate }}</p>
    }
    @if (dataStreams?.length) {
      <div class="row">
        @for (dataStream of dataStreams | datastreamFilter : searchText; track dataStream) {
          <app-data-stream [dataStream]="dataStream" [viewSetting]="viewSetting" [parentFormGroup]="parentFormGroup" [supplierContact]="dataStream.contact!" [select]="selectSubject" class="col-12 mb-3 datastream" [class]="{ 'col-md-6': viewSetting == 'TILE', 'col-lg-4': viewSetting == 'TILE' }"></app-data-stream>
        }
      </div>
    }
  </div>
}
